export const NAMESPACE = '@sail/observability';

//# sourceMappingURL=constants.js.map